import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="634" height="24" viewBox="0 0 634 24" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" {...props}><path d="M1.92 17.38C208.23-1.72 423-3.08 631.24 7.96M3.1 10.88c241.58 14 484.03 14.23 629.42 5.51" stroke="#000" strokeWidth="2" strokeLinecap="round" /></svg>);